<template>
  <el-dialog
    :close-on-click-modal="false"
    title="ETC充值"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="410px"
  >
    <section v-loading="getDetailLoading">
      <div class="recharge-remark">
        <p class="title">操作流程说明：</p>
        <ol class="content">
          <li>1、操作流程：ETC充值--->审核（ETC卡充值记录）--->付款（公司支付）-->核销（ETC卡充值记录）。</li>
          <li>2、付款是打款到ETC卡服务商指定的的账户。</li>
          <li>3、充值金额已到ETC卡后进行核销。</li>
        </ol>
      </div>
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData" />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  etcCardRecharge,
  toEtcCardRecharge,
} from 'api/service';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '车牌号',
            value: 'bindVehicle',
            type: 'input',
            readonly: true,
          },
          {
            label: 'ETC卡号',
            value: 'etcId',
            type: 'input',
            readonly: true,
          },
          {
            label: '余额',
            value: 'etcBalance',
            type: 'input',
            readonly: true,
          },
          {
            label: '充值金额',
            value: 'rechargeAmount',
            type: 'input',
            default: '',
            unit: '元',
            placeholder: '请输入充值金额',
          },
          {
            label: '服务商',
            value: 'serviceName',
            type: 'input',
            readonly: true,
          },
          {
            label: '收款账户',
            value: 'acctName',
            type: 'input',
            readonly: true,
          },
          {
            label: '收款账号',
            value: 'acctNo',
            type: 'input',
            readonly: true,
          },
          {
            label: '开户银行',
            value: 'branchName',
            type: 'input',
            readonly: true,
          },
        ],
        rules: { // 表单验证规则
          rechargeAmount: [ // 充值金额
            { required: true, message: '请输入充值金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
      this.subLoading = false;
      this.getRechargeInfo(item);
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    async getRechargeInfo (item) {
      const res = await toEtcCardRecharge({
        id: item.id,
      });
      if (!res.failed) {
        const data = {
          bindVehicle: res.etcMaintain && (res.etcMaintain.bindVehicle || item.bindVehicle),
          etcId: res.etcMaintain && (res.etcMaintain.etcId || item.etcId),
          etcBalance: res.etcMaintain && (res.etcMaintain.etcBalance || item.etcBalance),
          serviceName: res.etcMaintain && (res.etcMaintain.serviceName || item.serviceName),
          rechargeAmount: '',
          acctName: res.accountBankRel && (res.accountBankRel.acctName || ''),
          acctNo: res.accountBankRel && (res.accountBankRel.acctNo || ''),
          branchName: res.accountBankRel && (res.accountBankRel.branchName || ''),
        };
        this.$nextTick(() => {
          this.$refs.customForm && this.$refs.customForm.setVal(data);
        });
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      if (this.originData.id) {
        this.subLoading = true;
        const res = await etcCardRecharge({
          id: this.originData.id,
          rechargeAmount: form.rechargeAmount,
        });
        this.subLoading = false;
        if (!res.failed) {
          this.dialogFormVisible = false; // 关闭弹窗
          this.$message({
            type: 'success',
            message: '充值成功',
          });
          this.$emit('sub');
        }
      } else {
        this.$message({
          type: 'warning',
          message: '缺少卡信息',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-remark {
  color: #999999;
  margin-top: -20px;
  margin-bottom: 10px;
  .title {
  }
  .content {
    line-height: 1.6;
    padding: 5px 0;
  }
}
</style>
